import { BaseLayer } from '../layers/BaseLayer.js';
import { UVGridGenerator } from '../utils/checkerboard.js';

/********************************/
/*    TEXTURE TESTER LAYER      */
/********************************/

/**
 * Texture tester layer - example template for creating custom gem textures
 * This layer demonstrates how to create animated textures that respond to camera rotation
 */
export class TextureTesterLayer extends BaseLayer {
  constructor(width, height, density) {
    super(width, height, density, true);
    this.bgImage = null;
  }

  setup() {
    pixelDensity(this.density);
    // Rest of the user-defined setup code...
    background("red");

    let patternGen = new UVGridGenerator(this.width, this.height);
    this.bgImage = patternGen.generatePattern();
  }

  draw() {
    // Rest of the user-defined draw code...

    clear();

    image(this.bgImage, -this.width / 2, -this.height / 2, this.width, this.height);

    // a value that goes from 0 to 1 as the animation progresses
    // you can use this to make sure your animation loops properly
    let p = this.loopPercent;

    push();

    translate(-this.width / 2, -this.height / 2);

    // draw the loop percentage as text
    push();
    fill(255);
    textSize(32 * (this.width * 0.005));
    textAlign(CENTER, CENTER);
    text(`Loop: ${(p * 100).toFixed(1)}%`, this.width * 0.5, this.height * 0.5 - 32);
    pop();

    // draw a circle of boxes that rotate around the center
    let numBoxes = 10;
    let boxSize = this.width * 0.1;
    let circleRadius = this.width * 0.25;
    push();
    translate(this.width / 2, this.height / 2, this.width * 0.2);
    rotate(this.rotationX * PI * 2);
    for (let i = 0; i < numBoxes; i++) {
      push();
      rotate((i * TWO_PI) / numBoxes);
      translate(circleRadius, 0);
      rotateX(this.rotationY * PI * 2);
      rotateY(this.rotationX * PI * 1.5);
      rotateZ(this.rotationY * PI * 0.75);
      fill(255);
      strokeWeight(this.width * 0.002);
      box(boxSize);
      pop();
    }
    pop();

    pop();
  }
}
